import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';
import { rem } from '../../utils/utils';

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(['container', 'title', 'items']);

const DataWidgetTooltipTheme = defineMultiStyleConfig({
  baseStyle: ({ infoLabel, title }) => {
    return {
      container: {
        display: 'flex',
        gap: '8',
        alignItems: 'center',
        height: '40',
        paddingInlineStart: !title ? '8' : undefined,
        paddingInlineEnd: '8',
        width: 'fit-content',
        boxShadow: 'small',
      },
      title: {
        display: 'inline-block',
        paddingInlineStart: '16',
        paddingInlineEnd: infoLabel ? '12' : '16',
        paddingY: rem(9),
        backgroundColor: 'sys/neutral/subtle',
        borderTopLeftRadius: rem(7),
        borderBottomLeftRadius: rem(7),
        textStyle: 'body/md/semibold',
      },
      items: {
        display: 'flex',
        gap: '4',
        alignItems: 'center',
        paddingInlineStart: '8',
        paddingInlineEnd: '4',
        '> div': {
          display: 'flex',
          gap: '4',
          alignItems: 'center',
        },
        '> div + div': {
          _before: {
            content: `'\\B7'`,
            fontSize: '7',
            marginInline: 4,
            color: 'icon/tertiary',
          },
        },
      },
    };
  },
});

export default DataWidgetTooltipTheme;
